import { Flex, Separator } from '@radix-ui/themes';
import type { Editor } from '@tiptap/react';
import { ImageUploadButton } from './ImageUploadButton';
import { VideoUploadButton } from './VideoUploadButton';
import styles from './EditorToolbar.module.scss';

interface EditorToolbarProps {
  editor: Editor;
  snippetId: string;
}

export function EditorToolbar({ editor, snippetId }: EditorToolbarProps) {
  return (
    <Flex
      gap="1"
      p="2"
      align="center"
      className={styles.toolbar}
    >
      <ImageUploadButton editor={editor} snippetId={snippetId} />
      <VideoUploadButton editor={editor} snippetId={snippetId} />
    </Flex>
  );
}
